import { AutogenModelDrsPendingDeduct, AutogenRowDrsPendingDeduct } from "./autogen/AutogenModelDrsPendingDeduct";

export class ModelDrsPendingDeduct extends AutogenModelDrsPendingDeduct<RowDrsPendingDeduct> {
	constructor() {
		super(RowDrsPendingDeduct);
	}
}

export class RowDrsPendingDeduct extends AutogenRowDrsPendingDeduct {
}